import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {seatingType_list_action,seatingType_delete_action
} from "../../../actions/master_actions/seatingType_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { StatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillList_action";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";
class seatingTypeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      SittingTypeID: "",
      SittingTypeName: "",
      StatusID: "",
      Code: "",
      seatingTypeList: [],
      statusFillList: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.navigateEventAdd = this.navigateEventAdd.bind(this);
    this.getSittingList = this.getSittingList.bind(this);
    this.navigateEventUpdate = this.navigateEventUpdate.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getSittingList();
    this.getFillList(StatusActionId, userId, "", "");
  }

  navigateEventUpdate(SittingTypeID, StatusID) {
    console.log(SittingTypeID, StatusID);
    this.props.navigate("/seatingTypeAU", {
      state: { SittingTypeID: SittingTypeID, StatusID: StatusID },
    });
  }

  navigateEventAdd() {
    this.props.navigate("/seatingTypeAU");
  }

  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == StatusActionId) {
            this.setState({ statusFillList: data.data, isLoading: false });
            console.log(data.data, "status");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getSittingList = async () => {
    const { userId, SittingTypeName, StatusID } = this.state;
    this.setState({ isLoading: true });

    const finalStatus = StatusID == "InActive" ? 0 : StatusID=="Active"?1:null;
    this.props
      .seatingType_list_action( SittingTypeName, finalStatus)
      .then((data) => {
        console.log(data);
        if (data.error !== 1) {

          this.setState({
            seatingTypeList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(this.state.seatingTypeList);
    }, 500);
  };

  handleDelete(SittingTypeID) {
    const { userId } = this.state;
    const confirmed = window.confirm(
      "Are you sure you want to delete this Seating Type?"
    );

    if (confirmed) {
      this.props
        .seatingType_delete_action(SittingTypeID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getSittingList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  seatingRecord(seatingTypeList) {
    // const { userList } =this.state
    return (
      <table
        className="table table-bordered table-striped"
        id="dashboard-table"
      >
        <thead>
          <tr>
            <th style={{ width: "10%" }}>Seating Type</th>
            <th class="text-center" style={{ width: "5%" }}>
              Status
            </th>
            <th className="text-center" style={{ width: "5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {seatingTypeList != "" && seatingTypeList != null ? (
            seatingTypeList.map((item) => (
              <tr>
                <td>{item.SittingTypeName}</td>
                <td class="text-center">
                  {item.StatusID === 1 ? "Active" : "Inactive"}
                </td>
                <td class="text-center">
                  <a
                    href="javascript:void(0);"
                    onClick={() =>
                      this.navigateEventUpdate(
                        item.SittingTypeID,
                        item.StatusID
                      )
                    }
                    title="Edit"
                    className="btn btn-sm"
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  {item.StatusID==1?(
                    
                    <a
                    title="Delete"
                    className="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(item.SittingTypeID)}
                    >
                    <i className="fa fa-trash action_btn_table" />
                  </a>
                  ):<></>}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    const {
      isLoading,
      seatingTypeList,
      isAccordionExpanded,SittingTypeName,StatusID,
      statusFillList,
      currentPage,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = seatingTypeList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(seatingTypeList.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">List of Seating Type</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateEventAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search:</h4>
                        <div className="searched_items">
                          <h5>
                          Seating Type : <span>{SittingTypeName}</span>
                          </h5>
                          <h5>
                            Status : <span>{StatusID}</span>
                          </h5>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Seating Type</label>
                                <input
                                  type="text"
                                  value={SittingTypeName}
                                  onChange={(e) =>
                                    this.setState({ SittingTypeName: e.target.value })
                                  }
                                  className="form-control search_form_control"
                                  placeholder="Enter Seating Type"
                                />
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  value={StatusID}
                                  onChange={(e) =>
                                    this.setState({ StatusID: e.target.value })
                                  }
                                >
                                  <option selected={StatusID==null}>Select Status</option>
                                  {statusFillList.length > 0
                                    ? statusFillList.map((data) => (
                                        <option
                                          key={data.Status}
                                          value={data.Status}
                                        >
                                          {data.Status}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.getSittingList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={() => {
                                  this.setState(
                                    {
                                      StatusID: null,
                                      SittingTypeName: "",currentPage:1
                                    },
                                    () => this.getSittingList()
                                  );
                                }}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.seatingRecord(currentRecords)}
                      {seatingTypeList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {seatingType_list_action,seatingType_delete_action,
    fill_action,
  })(seatingTypeList)
);
